<template>
  <div class="page_">
    <div class="content">
      <div class="tit_">
        <a-row class="tit_1">
          {{ $t("checkout.tit") }}
        </a-row>
        <div class="line_"></div>
        <a-row class="tit_2">
          <a-col :span="6">
            {{ $t("checkout.name") }}：{{ orderInfo.product }}
          </a-col>
          <a-col :span="6">
            {{ $t("checkout.date") }}：{{ orderInfo.createDate }}
          </a-col>
          <a-col :span="8">
            {{ $t("checkout.order") }}：{{ orderInfo.orderNo }}
          </a-col>
          <a-col :span="4">
            {{ $t("checkout.amount") }}：<a
              >{{ $t("checkout.symbol") }}{{ orderInfo.money
              }}{{ $t("checkout.unit") }}</a
            >
          </a-col>
        </a-row>
      </div>
      <div class="pay_type_">
        <a-row class="tit_" type="flex">
          <a-col :span="12">
            {{ $t("checkout.mode") }}
            <a style="margin-left: 12px;"
              >{{ $t("checkout.paymentof") }}：{{ $t("checkout.symbol") }}
              {{ orderInfo.money }}{{ $t("checkout.unit") }}</a
            >
          </a-col>
          <a-col style="text-align: right;" :span="12">
            <img
              class="i_time_"
              src="~@/assets/medilinkPC/cashier/4.svg"
            />等待支付，剩余{{ remainTime }}
          </a-col>
        </a-row>
        <div class="line_"></div>
        <template v-if="showPayType">
          <div v-if="paymentMethod.indexOf(1) > -1" class="type_1">
            <a-radio
              value="1"
              @change="wechatPayMethodChange"
              :checked="wechatChecked"
            ></a-radio>
            <img
              class="img_"
              src="~@/assets/medilinkPC/cashier/wechat.png"
              alt=""
            />
            <span>{{ $t("checkout.weChat") }}</span>
          </div>
          <div v-if="paymentMethod.indexOf(2) > -1" class="type_2">
            <a-radio
              value="2"
              @change="alipayMethodChange"
              :checked="alipayChecked"
            ></a-radio>
            <img
              class="img_"
              src="~@/assets/medilinkPC/cashier/alipay.png"
              alt=""
            />
            <span>{{ $t("checkout.alipay") }}</span>
          </div>
          <div v-if="paymentMethod.indexOf(3) > -1" class="type_2">
            <div>
              <a-radio
                value="3"
                @change="bankCardPayMethodChange"
                :checked="bankChecked"
              ></a-radio>
              <img
                class="img_"
                src="~@/assets/medilinkPC/cashier/bankcard.svg"
                alt=""
              />
              <span>{{
                selectedCardInfo.title
                  ? selectedCardInfo.title
                  : $t("checkout.card")
              }}</span>
              <a-popover trigger="click" placement="bottom">
                <template slot="content">
                  <ul class="card_list_">
                    <li
                      :class="selectedCardInfo.id == item.id ? 'active_' : ''"
                      @click="handleChange(item)"
                      v-for="item in bankList"
                    >
                      {{ item.title }}<i></i>
                    </li>
                  </ul>
                </template>
                <a v-if="bankList.length > 1" class="mrg_l8_">更换</a>
              </a-popover>
            </div>
            <div @click="showPayType = false" class="add_bank_card_">
              {{ $t("cashierDesk[0]") || "添加银行卡"
              }}<svg
                class="svg_arrow_r_"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="14"
                viewBox="0 0 16.66 29"
              >
                <path
                  id="箭头"
                  fill="none"
                  fill-rule="evenodd"
                  stroke-width="2"
                  stroke="#2C5ACC"
                  class="cls-1"
                  d="M1606.76,6228.01l13.23,13.49-13.23,13.49"
                  transform="translate(-1604.34 -6227)"
                />
              </svg>
            </div>
          </div>
          <a-button type="primary" class="btn_" @click="pay">{{
            $t("checkout.confirm")
          }}</a-button>
        </template>
        <addBankCardPannel
          @cancel="showPayType = true"
          @showTipsModal="showCardTipsModal = true"
          @showAgreement="showAgreementModal = true"
          @ok="handleSuccessAddCard"
          v-else
        ></addBankCardPannel>
      </div>
    </div>
    <a-modal
      width="20%"
      :visible="success"
      :footer="false"
      @cancel="close('success')"
    >
      <div
        style="height: 250px;display:flex;flex-direction: column;justify-content: center;align-items:center;"
      >
        <img
          src="../../assets/medilinkPC/cashier/success.png"
          alt=""
          style="width: 104px;height: 104px;"
        />
        <span style="font-size: 18px;margin-bottom: 10px;">支付成功</span>
        <span>成功支付￥{{ orderInfo.money }}元</span>
      </div>
    </a-modal>
    <a-modal
      width="20%"
      :visible="error"
      :footer="false"
      @cancel="close('error')"
    >
      <div
        style="height: 250px;display:flex;flex-direction: column;justify-content: center;align-items:center;"
      >
        <img
          src="../../assets/medilinkPC/cashier/error.png"
          alt=""
          style="width: 104px;height: 104px;"
        />
        <span style="font-size: 18px;margin-bottom: 10px;">支付失败</span>
        <span>银行卡余额不足</span>
      </div>
    </a-modal>
    <a-modal
      width="20%"
      :visible="isPay"
      :footer="false"
      @cancel="close('isPay')"
    >
      <div
        style="height: 250px;display:flex;flex-direction: column;justify-content: center;align-items:center;"
      >
        <img :src="codeUrl" alt="" style="" />
        <span style="font-size: 16px;margin-top: 10px;"
          >请扫描二维码进行支付</span
        >
      </div>
    </a-modal>
    <!-- 支付宝支付form容器 -->
    <div style="display: none" v-html="aliPayModelHtml"></div>
    <inputCodeModal
      v-if="showCodeModal"
      :mobile="selectedCardInfo.mobile"
      @reGetPayCode="handleReGetPayCode"
      @ok="handleConfirmPay"
      @cancel="showCodeModal = false"
      :visible="showCodeModal"
    ></inputCodeModal>
    <payAgreementModal
      @cancel="showAgreementModal = false"
      :visible="showAgreementModal"
    ></payAgreementModal>
    <bankCardTipsModal
      @cancel="showCardTipsModal = false"
      :visible="showCardTipsModal"
    ></bankCardTipsModal>
  </div>
</template>

<style lang="scss" scoped>
.i_time_ {
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 3px;
}
.card_list_ {
  padding: 0;
  .active_ {
    color: #2c5acc;
  }
}
.page_ {
  color: #394155;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  .content {
    width: 80%;
    padding-top: 30px;
    margin: 0 auto;
    .line_ {
      border-bottom: 1px solid #eee;
    }
    .tit_ {
      // height: 126px;
      background-color: #fff;
      border-radius: 10px;

      .tit_1 {
        font-weight: 500;
        font-size: 16px;
        height: 55px;
        line-height: 55px;
        padding-left: 29px;
      }
      .tit_2 {
        padding: 20px 29px;
        // height: 70px;
        // line-height: 70px;
        display: flex;
        align-items: center;
      }
    }
    .pay_type_ {
      background-color: #fff;
      border-radius: 10px;
      margin-top: 20px;
      padding-bottom: 20px;
      .tit_ {
        font-weight: 500;
        font-size: 16px;
        height: 55px;
        line-height: 55px;
        padding: 0 29px;
      }
      .type_1 {
        padding-left: 29px;
        margin-top: 30px;
      }
      .type_2 {
        padding-left: 29px;
        margin-top: 20px;
        .add_bank_card_ {
          color: #2c5acc;
          padding-left: 54px;
          margin-top: 6px;
        }
      }
      .btn_ {
        width: auto;
        margin-left: 29px;
        margin-top: 40px;
      }
      .img_ {
        width: 20px;
        height: 20px;
        margin: 0 8px;
      }
    }
  }
  .mrg_l8_ {
    margin-left: 8px;
  }
  .svg_arrow_r_ {
    top: 1px;
    width: 12px;
    height: 12px;
    position: relative;
  }
}
</style>

<script>
import api from "@/utils/api";
import debounce from "lodash/debounce";
import { setLogined, setLang } from "@/utils/authorized";
import moment from "moment";
import addBankCardPannel from "./components/addBankCardPannel";
import inputCodeModal from "./components/inputCodeModal";
import payAgreementModal from "./components/payAgreementModal";
import bankCardTipsModal from "./components/bankCardTipsModal";

export default {
  inject: ["reload"],
  data() {
    return {
      payType: "",
      success: false,
      error: false,
      orderInfo: {
        remainTime: 0
      },
      remainTime: 0,
      isPay: false,
      codeUrl: "",
      si: "",
      wechatChecked: false,
      alipayChecked: false,
      bankChecked: false,
      showPayType: true,
      showCodeModal: false,
      showCardTipsModal: false,
      showAgreementModal: false,
      bankList: [],
      selectedCardInfo: {},
      paymentMethod: [],
      aliPayModelHtml: "" // 支付宝付款弹窗html字符串
    };
  },
  components: {
    addBankCardPannel,
    inputCodeModal,
    payAgreementModal,
    bankCardTipsModal
  },
  created() {
    this.getAgent();

    api
      .getMyBankCardList()
      .then(res => res.data)
      .then(data => {
        const list = data.content;
        this.bankList = list.map((item, index) => {
          const title = this.getCardTitle(item);
          return {
            ...item,
            title
          };
        });
        if (this.bankList.length > 0) {
          this.selectedCardInfo = this.bankList[0];
        }
      });
  },
  mounted() {
    // this.getOrderStatus()
    let { language, paymentMethod, createDate } = this.$route.query;
    createDate = createDate.replace(
      /([\d\/]+)([^\d]+)(\d+)([^\d])([\d\:]+)/g,
      function($0, $1, $2, $3, $4, $5) {
        console.log($2, "createDate -> ");
        return (
          $1 + " " + ($2 == "下午" ? parseInt($3) + 12 : "0" + $3) + ":" + $5
        );
      }
    );

    this.orderInfo = {
      ...this.$route.query,
      createDate
    };
    this.paymentMethod = paymentMethod || [1, 2, 3];
    const lang =
      language == "CHINAESE" ? "zh-cn" : language ? "en-us" : "zh-cn";

    setLang(lang);
    moment.locale(lang);
    this.$i18n.locale = lang;
    // this.reload()
    let count = Math.floor(
      (Date.parse(new Date(this.orderInfo.expirationTimeStr)) - Date.now()) /
        1000
    );
    this.startCountTime(count);
  },
  methods: {
    startCountTime(count) {
      console.log("startCountTime -> ", count, this.remainTime);
      let arr = [];
      let seconds = count;
      let hours = 0;
      let minutes = 0;

      const MINUTE = 60;
      const HOUR = MINUTE * 60;

      seconds = seconds > 0 ? seconds : 0;
      hours = "0" + Math.floor(seconds / HOUR);
      seconds = seconds % HOUR;
      minutes = "0" + Math.floor(seconds / MINUTE);
      seconds = "0" + (seconds % MINUTE);

      arr.push(hours.substr(-2), minutes.substr(-2), seconds.substr(-2));

      this.remainTime = arr.join(":");
      let si = setInterval(() => {
        clearInterval(si);
        count--;
        if (count >= 0) {
          this.startCountTime(count);
        }
      }, 1000);
    },
    getAgent() {
      if (
        /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ||
        /micromessenger/i.test(navigator.userAgent)
      ) {
        const keyArr = [
          "id",
          "orderNo",
          "money",
          "product",
          "createDate",
          "language",
          "expirationTimeStr"
        ];
        let url = `${location.origin}/m/pay?`;
        keyArr.forEach(key => {
          url += `${key}=${this.$route.query[key]}&`;
        });
        window.location.href = url;
      }
    },
    handleChange(item) {
      this.selectedCardInfo = {
        agreeId: item.agreeid,
        ...item
      };
    },
    getCardTitle(item) {
      let cardNo = item.acctNo || item.cardNo;
      cardNo = cardNo.replace(/\s/g, "");
      const title = `${item.bankName || item.bankname}${
        item.acctType == "00" ? "储蓄卡" : "信用卡"
      } （${cardNo.substr(-4)}）`;
      return title;
    },
    handleSuccessAddCard(data) {
      this.selectedCardInfo = {
        ...data,
        title: this.getCardTitle(data),
        agreeId: data.agreeid
      };
      this.showPayType = true;
    },
    handleReGetPayCode() {
      api
        .reGetPayCode({
          agreeId: this.selectedCardInfo.agreeId,
          orderId: this.applyBankCardPayInfo.orderid,
          thpinfo: this.applyBankCardPayInfo.thpinfo
        })
        .then(res => res.data);
    },
    handleConfirmPay(val) {
      api
        .confirmPay({
          agreeId: this.selectedCardInfo.agreeId,
          orderId: this.applyBankCardPayInfo.orderid,
          thpinfo: this.applyBankCardPayInfo.thpinfo,
          smsCode: val
        })
        .then(res => res.data)
        .then(data => {
          this.showCodeModal = false;
          this.success = true;
          const { returnUrl } = data.content;
          if (returnUrl) {
            let st = setTimeout(() => {
              clearTimeout(st);
              window.location.href = returnUrl;
            }, 3000);
          }
        });
    },
    close(type) {
      if (type == "error") {
        this.error = false;
      } else if (type == "success") {
        this.success = false;
      } else {
        this.isPay = false;
        this.$message.error("您已取消了支付");
        clearInterval(this.si);
      }
    },
    wechatPayMethodChange(e) {
      this.wechatChecked = e.target.checked;
      if (this.wechatChecked) {
        this.bankChecked = false;
        this.alipayChecked = false;
        this.payType = 1;
      } else {
        this.payType = "";
      }
    },
    alipayMethodChange(e) {
      this.alipayChecked = e.target.checked;
      if (this.alipayChecked) {
        this.wechatChecked = false;
        this.bankChecked = false;
        this.payType = 2;
      } else {
        this.payType = "";
      }
    },
    bankCardPayMethodChange(e) {
      this.bankChecked = e.target.checked;
      if (this.bankChecked) {
        this.wechatChecked = false;
        this.alipayChecked = false;
        this.payType = 3;
      } else {
        this.payType = "";
      }
    },
    pay() {
      if (!this.payType) {
        this.$message.error("请选择支付方式");
        return false;
      }
      if (this.bankChecked) {
        api
          .applyPay({
            payOrderInfoId: this.orderInfo.id,
            agreeId:
              this.selectedCardInfo.agreeid || this.selectedCardInfo.agreeId
          })
          .then(res => res.data)
          .then(data => {
            const { orderid, errmsg } = data.content;
            if (errmsg && !orderid) {
              this.$message.info(errmsg);
              return;
            }
            this.applyBankCardPayInfo = data.content;
            this.showCodeModal = true;
          });
        return;
      }
      let param = {
        id: this.orderInfo.id,
        payType: this.payType,
        subject: "P"
      };
      api
        .pay(param)
        .then(res => res.data)
        .then(data => {
          // 如果是支付宝支付
          if (this.payType === 2) {
            const htmlStr = data.content.split("<script>")[0];
            this.aliPayModelHtml = htmlStr;
            this.$nextTick(() => {
              document.forms[0].submit();
            });
          } else {
            let url = data.content;
            // let url = 'weixin://wxpay/bizpayurl?pr=h4GaFt8zz'
            this.isPay = true;
            import("jr-qrcode").then(jrQrcode => {
              var imgBase64 = jrQrcode.getQrBase64(url);
              this.codeUrl = imgBase64;
            });
            this.si = setInterval(() => {
              this.getOrderStatus();
            }, 1000);
          }
        });
      // axios.post(`http://provider.medilink-global.com.cn/api/medilinkPay/checkoutCounter/pay?id=${this.orderInfo.id}&payType=${this.payType}&subject=P`
      // ).then(response => {
      //     console.log(response);
      //   })
    },
    getOrderStatus() {
      api.getOrderStatus({ id: this.orderInfo.id }).then(res => {
        console.log(res);
        let content = res.data.content;
        if (content.payStatus == "2") {
          this.$message.success("支付成功");
          clearInterval(this.si);
          this.isPay = false;
          // 支付成功跳转
          window.location.href = content.returnUrl;
        }
        // else if (res.data.content == 'N'){
        //   this.$message.error('支付失败，请重新扫描二维码进行支付')
        //   clearInterval(this.si)
        //   this.si = null
        // }
      });
    }
  }
};
</script>
